import { useQuery } from "react-query";
import { ReferentialApi } from "../../api";
import { useApiService } from "../useApiService";

export function useGradeRef() {
  const api = useApiService(ReferentialApi);
  const { data, isFetching, refetch } = useQuery(
    "ref-grades",
    async () => {
      return await api.grades();
    },
    { staleTime: Infinity }
  );

  return {
    grades: data ?? [],
    gradesLoading: isFetching,
    refetchGradesRef: refetch,
  };
}
